<template>
<div>
    <v-container fluid class="bkground">
    <v-card flat class="mb-4 rounded-lg">
    <v-card-title>
        Archivos de Seguimiento
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
        <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
    </v-card-title>
    <v-card-subtitle>
      <div>
        <strong>
        {{getTitulos.enteFiscalizador || ''}}
        </strong>
      </div>
      <div>
      {{ getTitulos.nombreAuditoria || ''}}
      </div>
    </v-card-subtitle>
    <v-card-text>
    </v-card-text>
    <v-simple-table class="pa-3">
    <template v-slot:default>
    <thead>
        <tr>
        <template v-for="header in headers">
            <template>
            <th :key="header.id">
                {{ header.text }}
            </th>
            </template>
        </template>
        </tr>
    </thead>
    <tbody>
<template v-for="detalle in getListadoAuditoriasInformesObservacionesDetallesSeguimientosArchivos">
        <template>
            <tr :key="detalle.id" class="body-1">
            <td>
                <v-chip
                outlined
                >
                {{ new Date(detalle.createdAt).toISOString().slice(0, 10)}}
                </v-chip>
            </td>
            <td>
                <span class="text-subtitle-2 font-weight-medium bkgSecundary--text ">
                {{detalle.accion}}
                </span>
            </td>
            <td>
                <v-tooltip v-if="detalle.fileData && detalle.fileData !== ''
                && evaluaVer(detalle.fileData)" top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        color="red"
                        @click="verPdf(detalle.fileData)"
                        >
                        <v-icon>mdi-file-pdf-box</v-icon>
                        </v-btn>
                    </template>
                <span>
                    Ver PDF
                </span>
                </v-tooltip>
            </td>
            <td>
                <v-tooltip v-if="detalle.fileData && detalle.fileData !== ''" top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="descargarArchivo(detalle.fileData)"
                    >
                    <v-icon>mdi-download</v-icon>
                    </v-btn>
                </template>
                <span>
                    Descargar Archivo
                </span>
                </v-tooltip>
            </td>
            <td>
                <div class="mb-1 mt-1" v-if="detalle.numeroContrato">
                <v-btn
                    class="text-capitalize"
                    color="info"
                    plain
                    small
                >
                    {{ detalle.numeroContrato }}
                </v-btn>
                </div>
                <div>
                    <span class="text-caption font-weight-regular black--text ">
                        {{ detalle.textoDetalle }}
                    </span>
                </div>
            </td>
            <td>
                <v-row no-gutters class="rounded-lg grey lighten-5 pa-1 mb-1 mt-1">
                <v-col cols="2">
                    <v-badge inline :content="detalle.numeroObservacion"> </v-badge>
                </v-col>
                <v-col cols="10">
                    <span class="text-caption font-weight-regular black--text ">
                    {{ detalle.descripcionObservacion }}
                    </span>
                    <v-chip x-small
                    :color="getColorStatus(detalle.estatusObservacion)" dark>
                        {{ detalle.estatusObservacion }}
                    <v-icon right x-small
                        v-if="detalle.estatusObservacion === 'SOLVENTADA'">
                        mdi-check
                    </v-icon>
                    </v-chip>
                </v-col>
                </v-row>
                <v-row no-gutters class="my-2">
                </v-row>
            </td>
            <td>
                <span class="text-caption font-weight-regular black--text ">
                {{ detalle.nombreInforme }}
                </span>
            </td>
            </tr>
        </template>
        </template>
    </tbody>
    </template>
    </v-simple-table>
    </v-card>
    </v-container>
    <v-dialog v-model="mostrarPdfInforme" persistent scrollable width="750px">
      <v-card>
        <v-card-title>
          Vista previa PDF
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelarVerPdf()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <VistaPreviaPdf v-if="esteInforme" :ruta-archivo="esteInforme"> </VistaPreviaPdf>
        </v-card-text>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
import AUDITORIAS_INFORMES_OBSERVACIONES_DETALLES_SEGUIMIENTOS_ARCHIVOS from '@/graphql/querys/administracion/auditorias/auditoriasInformesObservacionesDetallesSeguimientosArchivos.gql';
import VistaPreviaPdf from '@/components/administracion/auditorias/informes/verPdf.vue';
import mixDescargarArchivos from '@/helpers/mixDescargarArchivo';

export default {
  name: 'AuditoriasSeguimientosArchivos',
  mixins: [mixDescargarArchivos],
  props: {
    idAuditoria: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mostrarPdfInforme: false,
      esteInforme: null,
      headers: [
        {
          id: 'fecha',
          text: 'Fecha',
        },
        {
          id: 'accion-documento-pendiente',
          text: 'Archivo',
        },
        {
          id: 'ver-pdf',
          text: '',
        },
        {
          id: 'descargar',
          text: '',
        },
        {
          id: 'desglose',
          text: 'Desglose',

        },
        {
          id: 'observacion',
          text: 'Observación',
        },
        {
          id: 'informe',
          text: 'Informe',
        },
      ],
    };
  },
  components: {
    VistaPreviaPdf,
  },
  apollo: {
    auditoriasInformesObservacionesDetallesSeguimientosArchivos: {
      query: AUDITORIAS_INFORMES_OBSERVACIONES_DETALLES_SEGUIMIENTOS_ARCHIVOS,
      variables() {
        return {
          idAuditoria: this.idAuditoria,
        };
      },
    },
  },
  computed: {
    getAuditoriasInformesObservacionesDetallesSeguimientosArchivos() {
      if (!this.auditoriasInformesObservacionesDetallesSeguimientosArchivos) return [];
      return this.auditoriasInformesObservacionesDetallesSeguimientosArchivos;
    },
    getListadoAuditoriasInformesObservacionesDetallesSeguimientosArchivos() {
      return this.getAuditoriasInformesObservacionesDetallesSeguimientosArchivos
        .map((seguimiento) => ({
          idSeguimiento: seguimiento.id,
          accion: seguimiento.accion,
          comentariosSeguimiento: seguimiento.comentarios || '',
          fileData: seguimiento.fileData || '',
          idUsuarioRegistro: seguimiento.idUsuarioRegistro || '',
          createdAt: seguimiento.createdAt,
          updatedAt: seguimiento.updatedAt,

          // Detalle
          fechaVencimiento: seguimiento.auditoriaInformeObservacionDetalle.fechaVencimiento || '',
          comentariosDetalle: seguimiento.auditoriaInformeObservacionDetalle.comentariosDetalle || '',
          textoDetalle: seguimiento.auditoriaInformeObservacionDetalle.texto || '',
          numeroContrato: seguimiento.auditoriaInformeObservacionDetalle.contrato.numero || '',

          // Observación
          numeroObservacion: seguimiento
            .auditoriaInformeObservacionDetalle.auditoriaObservacion.numero || '',
          descripcionObservacion: seguimiento
            .auditoriaInformeObservacionDetalle.auditoriaObservacion.descripcion || '',
          estatusObservacion: seguimiento
            .auditoriaInformeObservacionDetalle.auditoriaObservacion.estatus || '',
          comentariosObservacion: seguimiento
            .auditoriaInformeObservacionDetalle.auditoriaObservacion.comentarios || '',

          // Informe
          nombreInforme: seguimiento
            .auditoriaInformeObservacionDetalle.auditoriaObservacion.auditoriaInforme.nombre || '',
          dataFileInforme: seguimiento
            .auditoriaInformeObservacionDetalle.auditoriaObservacion.auditoriaInforme.dataFile || '',

          // Auditoría
          nombreAuditoria: seguimiento.auditoriaInformeObservacionDetalle
            .auditoriaObservacion.auditoriaInforme.auditoria.nombre || '',
          enteFiscalizador: seguimiento.auditoriaInformeObservacionDetalle
            .auditoriaObservacion.auditoriaInforme.auditoria.enteFiscalizador.descripcion || '',
        }))
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) || [];
    },
    getTitulos() {
      if (!this.getListadoAuditoriaSeguimientoArchivos) return {};
      if (this.getListadoAuditoriaSeguimientoArchivos.length === 0) return {};
      const auditoriaTitulos = this.getListadoAuditoriaSeguimientoArchivos[0];
      return {
        enteFiscalizador: auditoriaTitulos.enteFiscalizador,
        nombreAuditoria: auditoriaTitulos.nombreAuditoria,
      };
    },
  },
  methods: {
    getDiasRestantes(fechaVencimiento) {
      const formatedFechaVencimiento = new Date(`${fechaVencimiento}`);
      const hoy = new Date();
      const diferenciasEnMilisegundos = formatedFechaVencimiento - hoy;

      return Math.floor(diferenciasEnMilisegundos / (1000 * 60 * 60 * 24));
    },
    getIconFechaVencimiento(fechaVencimiento) {
      const diferenciasEnDias = this.getDiasRestantes(fechaVencimiento);

      if (diferenciasEnDias <= 0) return 'mdi-clock-time-eleven-outline';

      if (diferenciasEnDias <= 7 && diferenciasEnDias > 0) return 'mdi-clock-time-seven-outline';

      return 'mdi-clock-time-two-outline';
    },
    getColorFechaVencimiento(fechaVencimiento) {
      const diferenciasEnDias = this.getDiasRestantes(fechaVencimiento);

      if (diferenciasEnDias <= 0) return '#EF5350';

      if (diferenciasEnDias <= 7 && diferenciasEnDias > 0) return 'warning';

      return 'success';
    },
    getColorStatus(estatus) {
      switch (estatus) {
        case 'PENDIENTE':
          return 'red darken-1';
        case 'POR RESPONDER':
          return 'orange';
        case 'RESPUESTA ENVIADA PARCIAL':
          return 'info';
        case 'RESPUESTA ENVIADA COMPLETA':
          return 'success';
        case 'SOLVENTADA':
          return 'green darken-1';
        default:
          return 'warning';
      }
    },
    verPdf(dataFileInforme) {
      this.mostrarPdfInforme = !this.mostrarPdfInforme;
      this.esteInforme = dataFileInforme;
    },
    cancelarVerPdf() {
      this.mostrarPdfInforme = !this.mostrarPdfInforme;
      this.esteInforme = null;
    },
    async descargarArchivo(seguimientoFileData) {
      let fileData = null;
      if (seguimientoFileData) {
        fileData = JSON.parse(seguimientoFileData);
        fileData.publicKey = fileData.public_key;

        await this.mixDescargarArchivo(fileData, 'proyectoDocumentos');
      }
    },
    evaluaVer(seguimientoFileData) {
      let fileData = null;

      if (seguimientoFileData) {
        fileData = JSON.parse(seguimientoFileData);
        if (fileData.extension === 'pdf') return true;
      }
      return false;
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
};

</script>
